// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getAdData = contextConfiguration => axios.get(
	'/ad_data',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getAdData;
